import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would implement actual authentication here
    console.log('Login attempt:', { email, password });
    alert('Login is currently disabled, please try again later. Apologies.');
  };
  
  return (
    <>
      <Helmet>
        <title>Sign In | Quick Flick</title>
      </Helmet>
      <main>
        <div className="container">
          <div style={{ 
            maxWidth: '450px', 
            margin: '120px auto 50px',
            padding: '30px',
            borderRadius: '8px',
            backgroundColor: 'var(--secondary-color)'
          }}>
            <h1 className="section-title" style={{ marginBottom: '25px', textAlign: 'center' }}>Sign In</h1>
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Email</label>
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                />
              </div>
              
              <div style={{ marginBottom: '25px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Password</label>
                <input 
                  type="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                />
                <div style={{ textAlign: 'right', marginTop: '8px' }}>
                  <a href="#" style={{ color: 'var(--primary-color)', textDecoration: 'none', fontSize: '0.9rem' }}>
                    Forgot password?
                  </a>
                </div>
              </div>
              
              <button 
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%', padding: '12px', marginBottom: '20px' }}
              >
                Sign In
              </button>
              
              <div style={{ textAlign: 'center' }}>
                <p>
                  New to Quick Flick? <Link to="/signup" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>Sign up now</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
};

export default LoginPage; 